module.exports = __webpack_public_path__ + "media/icons/gallery-next@3x-794d9c09.svg";